export default "__VITE_ASSET__CxpMmsWL__"